import { ReactComponent as VisibilityOffIcon } from './visibility_off.svg';

export default VisibilityOffIcon;
